import React from 'react';

// Material UI
import {Grid} from "@mui/material";

function ActionContainer(props) {
    return (
        <div
            style={{
                background: '#fff',
                padding: '16px',
                position: 'sticky',
                bottom: 0,
            }}
        >
            <Grid
                container
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    gap: '8px',
                }}
            >
                {props.children}
            </Grid>
        </div>
    );
}

export default ActionContainer;
